export function getProjectIdAtRegistry(carbonProjectListItemWithMetadata) {
    return carbonProjectListItemWithMetadata.CarbonProjectListItem.B.S?.C && carbonProjectListItemWithMetadata.CarbonProjectListItem.B.N
        ? `${carbonProjectListItemWithMetadata.CarbonProjectListItem.B.S.C} ${carbonProjectListItemWithMetadata.CarbonProjectListItem.B.N}`
        : undefined;
}
